import * as types from '../constants/ActionTypes'
import {handleActions} from 'redux-actions'
import {updateArrayItem} from '../utils/helpers'

const reducers = {}
const initialState = {
	list: []
}

reducers[types.GET_COMPANY_CANNED_MESSAGES] = (state, action) => {
	return Object.assign({}, state, {isLoading: true, isLoaded: false, loadError: false})
}

reducers[types.GET_COMPANY_CANNED_MESSAGES_FINISH] = {
	next(state, action) {
		return Object.assign({}, state, {
			list: action.payload.cannedMessages || [],
			isLoading: false,
			isLoaded: true
		})
	},
	throw(state) {
		return Object.assign({}, state, {isLoading: false, loadError: true})
	}
}

reducers[types.GET_AGENT_CANNED_MESSAGES] = (state, action) => {
	return Object.assign({}, state, {isLoading: true, isLoaded: false, loadError: false})
}

reducers[types.GET_AGENT_CANNED_MESSAGES_FINISH] = {
	next(state, action) {
		let newState

		if (Array.isArray(action.payload.cannedMessages))
			newState = Object.assign({}, state, {
				list: action.payload.cannedMessages.concat(state.list),
				isLoading: false,
				isLoaded: true
			})
		else
			newState = Object.assign({}, state, {isLoading: false, isLoaded: true})

		return newState
	},
	throw(state) {
		return Object.assign({}, state, {isLoading: false, loadError: true})
	}
}

reducers[types.CREATE_AGENT_CANNED_MESSAGE] = (state, action) => {
	return Object.assign({}, state, {isLoading: true, isLoaded: false, loadError: false})
}

reducers[types.CREATE_AGENT_CANNED_MESSAGE_FINISH] = {
	next(state, action) {
		return Object.assign({}, state, {
			list: [action.payload.cannedMessage, ...state.list],
			isLoading: false,
			isLoaded: true
		})
	},
	throw(state) {
		return Object.assign({}, state, {isLoading: false, loadError: true})
	}
}

reducers[types.UPDATE_AGENT_CANNED_MESSAGE] = (state, action) => {
	return Object.assign({}, state, {isLoading: true, isLoaded: false, loadError: false})
}

reducers[types.UPDATE_AGENT_CANNED_MESSAGE_FINISH] = {
	next(state, action) {
		return Object.assign({}, state, {
			list: updateArrayItem(state.list, message => message._id == action.payload.cannedMessage._id, action.payload.cannedMessage),
			isLoading: false,
			isLoaded: true
		})
	},
	throw(state) {
		return Object.assign({}, state, {isLoading: false, loadError: true})
	}
}

reducers[types.DELETE_AGENT_CANNED_MESSAGE] = (state, action) => {
	return Object.assign({}, state, {isLoading: true, isLoaded: false, loadError: false})
}

reducers[types.DELETE_AGENT_CANNED_MESSAGE_FINISH] = {
	next(state, action) {
		state.list.splice(state.list.findIndex(message => message._id == action.payload.cannedMessage._id), 1)

		return Object.assign({}, state, {
			list: [...state.list],
			isLoading: false,
			isLoaded: true
		})
	},
	throw(state) {
		return Object.assign({}, state, {isLoading: false, loadError: true})
	}
}

export default handleActions(reducers, initialState)
